import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { DATA } from "b2b/api/paths";
import { Projekt } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACZakaznikProjekty({ zakaznikICO, ...props }) {
  const { projektyLabel, projektyPlaceholder } = useMessages();

  return (
    <Field
      component={Inputs.AutoComplete}
      url={DATA.projekty(zakaznikICO)}
      rendererSelected={Projekt}
      rendererOption={Projekt}
      loadOnce
      staticKey={["nazevCz, nazevEn"]}
      minChars={0}
      label={projektyLabel()}
      placeholder={projektyPlaceholder()}
      descriptionRenderer={Projekt}
      {...props}
    />
  );
}

ACZakaznikProjekty.propTypes = {
  zakaznikICO: T.string,
  multiple: T.bool
};

export default React.memo(ACZakaznikProjekty);
